class AzNav extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    let links = "";
    const loc = getHandbookLocation();
    const locIndices = {
      1: "indices",
      2: "ocindices",
      4: "rindices",
    };
    const currentLetter = this.getCurrentLetter();
    const letters = Array.from("ABCDEFGHIJKLMNOPQRSTUVWYZ");

    const homeLinks = {
      1: "/path_handbook/index.html",
      4: "/path_handbook/rindex.html",
    };
    const handbookLocation = window.getHandbookLocation();
    const handbookHomeLink = homeLinks[handbookLocation];

    const homeLink = `<a href="${handbookHomeLink}" class="az-nav-home-link" title="Home"><i class="fa fa-solid fa-home"></i><span class="visually-hidden">Home</span></a> `;
    const letterLinks = letters
      .map((l) => {
        const active = l === currentLetter ? "class='active'" : "";
        return `<a href="/path_handbook/${locIndices[loc]}/${l}.html" ${active}>${l}</a>`;
      })
      .join(" ");

    links = homeLink + letterLinks;

    this.innerHTML = `
      <div class="az-nav-container">
        <div class="az-nav-letters">
          <p>${links}</p>
        </div>
      </div>
    `;
  }

  getCurrentLetter() {
    // Matches a single uppercase letter before ".html"
    const match = window.location.pathname.match(/\/([A-Z])\.html$/);
    return match ? match[1] : null;
  }
}

customElements.define("az-nav", AzNav);
